import React from "react";
import { Check } from "lucide-react";

const STEPS = ["Recipe", "Prepare", "Brew", "Ready"];

export function BrewProgress({ current }) {
  const active = Math.max(0, STEPS.indexOf(current));
  return (
    <div className="px-5 py-3" aria-label={`Brewing progress: ${current}`}>
      <div className="flex items-start">
        {STEPS.map((step, index) => (
          <React.Fragment key={step}>
            <div className="flex w-12 shrink-0 flex-col items-center gap-1">
              <div className={`flex h-7 w-7 items-center justify-center rounded-full border text-xs font-bold ${index <= active ? "border-[#EDE0CC] bg-[#EDE0CC] text-[#081F5C]" : "border-[#EDE0CC]/30 text-[#EDE0CC]/45"}`}>
                {index < active ? <Check size={15} /> : index + 1}
              </div>
              <span className={`text-[10px] ${index <= active ? "text-[#EDE0CC]" : "text-[#EDE0CC]/45"}`}>{step}</span>
            </div>
            {index < STEPS.length - 1 && <div className={`mt-3 h-px flex-1 ${index < active ? "bg-[#EDE0CC]" : "bg-[#EDE0CC]/20"}`} />}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
